import { text } from '@storybook/addon-knobs';
import { action } from '@storybook/addon-actions';
import { withInfo } from '@storybook/addon-info';
import { storiesOf } from '@storybook/react';
import * as React from 'react';
import { Radiobutton } from './radiobutton';

storiesOf('Radio Button', module).add('default', () => (
  <Radiobutton name="risk-tolerance" value={1} isChecked={true}>
    {'Moderately Conservative'}
  </Radiobutton>
));
